import { render, staticRenderFns } from "./productionSalesDetails.vue?vue&type=template&id=5676036c&"
import script from "./productionSalesDetails.vue?vue&type=script&lang=js&"
export * from "./productionSalesDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5676036c')) {
      api.createRecord('5676036c', component.options)
    } else {
      api.reload('5676036c', component.options)
    }
    module.hot.accept("./productionSalesDetails.vue?vue&type=template&id=5676036c&", function () {
      api.rerender('5676036c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/productionSalesDetails.vue"
export default component.exports